import { ArrowDownward, ArrowUpward, SwapVertOutlined } from '@mui/icons-material'
import { Box, Icon, IconButton, Popover } from '@mui/material'
import PropTypes from 'prop-types'
import React, { useRef, useState } from 'react'
import { Icons, sortByProperty } from '../../utils/utilities'

/**
 * @typedef {'small' | 'medium' | 'large'} MUIButtonSize
 * @typedef {'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit' | 'default'} MUIColor
 *
 /**
 * 
/**
 * Button component for triggering actions.
 *
 * @param {Object} props
 * @param {(React.ReactNode|String|Element)} [props.info] - Any details about the column.
 * @param {React.CSSProperties.alignItems} [props.align] - Align.
 * @param {(Object|Array)} [props.data] - Table data.
 * @param {Function} [props.data] - Table data setter functions.
 * @param {Function} props.label - Column label.
 * @param {Function} [props.setSortState] - Function to set sort state.
 * @param {String} [props.sortName] - Name of the column.
 * @param {String} [props.sortFlag] - Sort flag.
 * @param {String} [props.sortValueType] - Sort value type.
 * @param {String} [props.minWidth] - Minimum width of the column.
 */

const CustomTableColumnLabel = ( { info = null, align = "flex-start", data, setData, label, setSortState, sortKey, sortName, sortFlag, sortValueType, minWidth } ) => {

    const [openInfoDialog, setOpenInfoDialog] = useState( null )
    const columnContainer = useRef()

    return <Box display="flex" justifyContent={align} minWidth={minWidth} alignItems="center" gap="5px">
        {info && <Popover anchorEl={columnContainer.current} onClose={() => setOpenInfoDialog( false )} open={openInfoDialog}>
            {info}
        </Popover>}
        {info && <Icon onClick={() => setOpenInfoDialog( true )} sx={{ cursor: "pointer" }} ref={columnContainer}>{Icons.small.InfoIcon}</Icon>}
        {label}
        <IconButton onClick={
            () => {
                sortByProperty( data, setData, sortKey, sortValueType, sortFlag === "1" ? "-1" : "1" )
                setSortState( sortName, sortFlag === "1" ? "-1" : "1" )
            }
        } size="small" sx={{ cursor: "pointer", padding: "5px", "&:hover": { background: "rgba(0,0,0,0.4)", color: "white", } }}>
            {sortFlag === "1" ? <ArrowUpward sx={{ fontSize: "16px" }} /> : sortFlag === "-1" ? <ArrowDownward sx={{ fontSize: "16px" }} /> : <SwapVertOutlined sx={{ fontSize: "16px" }} />}
        </IconButton>
    </Box>
}

CustomTableColumnLabel.propTypes = {
    info: PropTypes.node,
    align: PropTypes.oneOf( ['right', 'left', 'center'] ),
    data: PropTypes.array.isRequired,
    setData: PropTypes.func.isRequired,
    setSortState: PropTypes.func,
    sortKey: PropTypes.string.isRequired,
    sortName: PropTypes.string,
    sortFlag: PropTypes.string,
    sortValueType: PropTypes.oneOf( ['string', 'number'] )
}

export default CustomTableColumnLabel
